import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ApiNokInterceptor } from './core/interceptors/api-nok.interceptor';
import { AnalyticsService } from './core/services/analytics.service';
import { AuthStore } from './store/auth.store';
import { LOCALE_ID } from '@angular/core';

export function authPersistInit(authStore: AuthStore): () => Promise<void> {
  return () => authStore.esperarHidratacion();
}

export function analyticsInit(analytics: AnalyticsService): () => void {
  return () => analytics.init();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot({
      backButtonText: '',
    }),
    AppRoutingModule,
    SharedModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-CL' },
    {
      provide: APP_INITIALIZER,
      useFactory: authPersistInit,
      deps: [AuthStore],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: analyticsInit,
      deps: [AnalyticsService],
      multi: true
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiNokInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
